import { ServerApi } from 'modules/api/server-api';

import { decodeSearchSession } from '@/models/Candidate/SearchSession';

export const fetchCandidateSuperSearchSession = (api: ServerApi) => async () => {
  const response = await api.get('/v3/candidate/search-session/status');
  return decodeSearchSession(response.data);
};
